import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TotalProveiderMonth } from "./helper";
import {
  getPayoutCountsNetworkAction,
  getProviderPayoutDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import CustomPagination from "../../../common/CustomPagination";
import { getNetworkMenuId } from "../../../Utils/types";
import { payOutHeaderValue } from "./AdditionalApptHeader";

export const TotalProvider = ({
  setSwitchTab,
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  downloadFile,
  setSelectAllFlag,
  setSelectAll,
  isLoadingExcel,
  header
}) => {
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setProviderDetail(providerDetail);
  // }, [providerDetail]);

  useEffect(() => {
    dispatch(
      getProviderPayoutDetailsNetworkAction({
        ...searchFilter,
        page: 1,
        rows: 10,
      })
    );
  }, []);

  return (
    <>
    <div className="table-responsive __custom__properties">
        <table className="table" >
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    payoutReducer?.getTotalProviderPayout?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(payoutReducer?.getTotalProviderPayout);
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>
              <th style={{ minWidth: "260px" }}>Provider ID/Name</th>
              <th style={{ minWidth: "100px" }}>Month</th>
              <th style={{ minWidth: "10%", textAlign: "center" }}>
                {" "}
                Appointment
              </th>
              <th style={{ minWidth: "130px", textAlign: "center" }}>Provider Amount</th>
              <th style={{ minWidth: "100px", textAlign: "center" }}>TDS</th>
              <th style={{ minWidth:"100px",textAlign: "center" }}>Net Amount</th>
              {header.map((ele) => {
                return <th style={{ minWidth: "150px", textAlign: "center" }}>{ele}</th>;
              })}
              <th style={{ textAlign: "center" }}>Status</th>
              <th style={{minWidth: "250px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
           {payoutReducer?.getTotalProviderPayout?.length !== 0 &&  <tbody>
            {payoutReducer?.getTotalProviderPayout?.map((ele, index) => {
              return (
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={providerDetail.some((item) => ele === item)}
                      onClick={(e) => {
                        if (e.target.checked) {
                          setProviderDetail([...providerDetail, ele]);
                        } else {
                          setSelectAllFlag(false);
                          setSelectAll(false);
                          setProviderDetail(
                            providerDetail?.filter((item) => ele !== item)
                          );
                        }
                      }}
                      readOnly
                    />
                  </td>
                  <td>
                    <a
                      className="text-highlighted text-decoration"
                      style={{ cursor: "pointer", margin: "auto" }}
                      onClick={() => {
                        setSearchFilter({
                          ...searchFilter,
                          month: ele?.month,
                          providerIds: ele?.providerId.toString(),
                        });
                        dispatch(
                          getPayoutCountsNetworkAction({
                            ...searchFilter,
                            month: ele?.month,
                            providerIds: ele?.providerId.toString(),
                          })
                        );
                        setSelectAll(false);
                        setSelectAllFlag(false);
                        setSwitchTab("totalApppointments");
                      }}
                    >
                      {ele?.providerName}
                    </a>
                  </td>
                  <td>{TotalProveiderMonth(ele?.year, ele?.month)}</td>
                  <td style={{ textAlign: "center" }}>
                    {ele?.totalAppointments}
                  </td>
                  <td style={{ textAlign: "center" }}>{ele?.grossAmount?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.tds?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.netAmount?.toLocaleString('en-IN')}</td>
                  {header.map((col, index) => {
                  return (
                    <td
                      key={index}
                      style={{textAlign:"center"}}
                    >
                       { ele[payOutHeaderValue[col]]}
                    </td>
                  );
                })}
                  <td style={{minWidht:"40%"}}>
                    <p
                      className={`status-style ${
                        ele?.paymentStatus === "Paid" ||
                        ele?.paymentStatus === "Advance Paid"
                          ? "approved"
                          : ele?.paymentStatus === "Reject By Finance" ||
                            ele?.paymentStatus === "Not Paid "
                          ? "rejected"
                          : ele?.paymentStatus ==="Pending For Provider" ? "refundStatus"
                          : ele?.paymentStatus === "Rejected By Provider" ? "rejected"
                          : ele?.paymentStatus === "Pending At Finance" ||
                            ele?.paymentStatus === "Pending at Network"
                          ? "pendingAtFinance"
                          : ele?.paymentStatus === "Pending For Payment"
                          ? "pendingForpayment"
                          : ele?.paymentStatus === "Partial Paid"
                          ? "partialPaid"
                          : (ele?.paymentStatus === "Refund" ||
                            ele?.paymentStatus === "Partial Refund" ||
                            ele?.paymentStatus === "Payment Lost")
                          ? "refundStatus"
                          : "pending"
                      }`}
                    >
                      {" "}
                      {ele?.paymentStatus}
                    </p>
                  </td>
                  <td>
                    <div className="d-flex gap-4">
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#sendToQcModal"
                        disabled={
                          getNetworkMenuId()?.canEdit === false
                            ? true
                            : ele?.isPayoutStatus === false ||
                              providerDetail.length > 1 ||
                              (ele?.paymentStatus !== "Pending At Network" &&
                                ele?.paymentStatus !== "Partial QC")
                            ? true
                            : ele?.isInvoiceGenerated===false?true:false
                        }
                        onClick={() => {
                          setProviderDetail([ele]);
                        }}
                      >
                        Send to QC &nbsp;
                        <i class="fa-solid fa-caret-right"></i>
                      </button>
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        disabled={isLoadingExcel || providerDetail?.length > 1}
                        onClick={() => {
                          downloadFile(ele);
                          setProviderDetail([...providerDetail, ele]);
                        }}
                      >
                        <i className="fa-solid fa-file-csv"></i>&nbsp;{" "}
                        {isLoadingExcel ? "Exporting..." : "Export"}
                      </button>
                    </div>
                  </td>
                 

                </tr>
              );
            })}
          </tbody>}
         
        </table>
        {payoutReducer?.getTotalProviderPayout?.length === 0 && <p className="noRecordFound">No Record Found</p>}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={getProviderPayoutDetailsNetworkAction}
            />
          )}
        </div>
      </div>
      
    </>
  );
};
